module.exports = __webpack_public_path__ + "media/images/landing/products/locator-1b5a0f3cf462e68d231468c035de9837.png";